import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { AppProvider, Page, DataTable, Card, Thumbnail, DisplayText, Button, Badge, ButtonGroup, Modal } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/es.json';
import axios from 'utils/axios';
import { ta } from 'utils';
import { ViewMinor } from '@shopify/polaris-icons';
import InformativeModal from '@presentational/order_supply/InformativeModal';

const propTypes = {
  orderSupply: PropTypes.object.isRequired,
  submitSyncURL: PropTypes.string,
  isAdmin: PropTypes.bool,
  intcomexOrderURL: PropTypes.string,
  sellerSpecialCostURL: PropTypes.string,
}
const defaultProps = {}

const OrderSupplyShow = (props) => {
  const [loading, setLoading] = useState(false);
  const { orderSupply } = props;
  // TODO use one state for records instead of two, because only one are displayed at a time
  const [resultModal, setResultModal] = useState({
    title: "",
    open: false,
    columns: [], // headers and values to display
    records: [], // actual records/rows
    errors: [], // errors to display
  })

  let dataTable = {
    columnData: ['text', 'text', 'text', 'text', 'text', 'text'],
    headData: [
      "",// I18n.t(`shopify.line_item.image`),
      ta(`general.title`),
      ta(`supply_item.option_name`),
      ta(`general.sku`),
      ta(`general.quantity`),
      ta(`supply_item.quantity_shipped`),
    ],
    rows: {}
  }
  let dataTableRows = orderSupply.supply_items.map(si => [
    <Thumbnail
      source={si.item_image_url}
    />,
    si.title,
    si.option_name,
    si.sku,
    si.quantity,
    si.quantity_shipped,
  ])

  const buildDataTable = () => {
    dataTable.columnData.push("text", "text")
    dataTable.headData.push(ta(`supply_item.intcomex_row_created`), ta(`supply_item.intcomex_quantity_purchased`))
    dataTable.rows = orderSupply.supply_items.map(si => [
      <Thumbnail
        source={si.item_image_url}
      />,
      si.title,
      si.option_name,
      si.sku,
      si.quantity,
      si.quantity_shipped,
      <Badge status={si.intcomex_row_created == "Si" ? "info" : "warning"}>
        {si.intcomex_row_created}
      </Badge>,
      si.intcomex_quantity_purchased,
    ])
  }


  const [intcomexPoID, setIntcomexPoID] = useState(props.orderSupply.intcomex_po_id); // Display intcomexPoID if it exists. Also disable some actions if already exists

  console.log(orderSupply)

  const handleCloseModal = useCallback(() => { setResultModal({ ...resultModal, open: false }) }, [resultModal]);

  const submitSyncWithBrightPearl = async () => {
    setLoading(true);
    let response = await axios.post(props.submitSyncURL);
    if (response.data.success) {
      alert("Tarea asignada, recargue unos momentos para ver los cambios.")
    }
    else {
      alert(I18n.t("messages.request_error"))
    }
    setLoading(false);
  }

  const submitCreatePO = async () => {
    setLoading(true);
    const modalTitle = "Crear PO via API";
    try {
      const { data } = await axios.post(props.intcomexOrderURL);
      console.log("submitCreatePO", data);
      if (data.success) {
        setResultModal({
          title: modalTitle,
          open: true,
          columns: [
            ta('general.sku'),
            ta('supply_item.intcomex_row_created'),
            ta('supply_item.intcomex_quantity_purchased'),
          ],
          records: data.records,
          errors: data.errors,
        });

        setIntcomexPoID(data.intcomex_po_id)
      } else {
        setResultModal({
          title: modalTitle,
          open: true,
          columns: [],
          records: [],
          errors: data.errors, // should be errors or messages
        });
      }
    } catch (e) {
      alert("error intentelo mas tarde")
      console.log("EEE", e);
    }
    setLoading(false);
  }

  const requestSpecialCost = async () => {
    setLoading(true);
    const modalTitle = "Consulta de costos especiales";
    try {
      const { data } = await axios.get(props.sellerSpecialCostURL)
      console.log(data)
      if (data.success) {
        setResultModal({
          title: modalTitle,
          open: true,
          columns: [
            ta('general.sku'),
            ta('general.unit_cost'),
          ],
          records: data.records,
          errors: [],
        });
      } else {
        setResultModal({
          title: modalTitle,
          open: true,
          columns: [],
          records: [],
          errors: data.errors, // should be errors or messages
        });
      }
    } catch (e) {
      alert("error intentelo mas tarde")
      console.log("EEE", e);
    }
    setLoading(false)
  }
  const brightPearlPoURL = props.isAdmin && `https://euw1.brightpearlapp.com/patt-op.php?scode=invoice&oID=${orderSupply.bright_pearl_po_id}` // Only production URL is set
  const intcomexVendor = orderSupply.vendor == 'Intcomex' || orderSupply.vendor.includes("Intcomex"); // Only display some actions for Intcomex vendor # TODO move this to backend

  return (
    <AppProvider i18n={translations}>
      <Page
        fullWidth
        breadcrumbs={[{ content: I18n.t("actions.back"), url: '/order_supplies' }]}
        title={`${orderSupply.display_bright_pearl_id}`}
        subtitle={!!intcomexPoID ? `Número de orden en Intcomex: ${intcomexPoID}` : undefined}
        titleMetadata={orderSupply.created_at_text}
        secondaryActions={!!brightPearlPoURL ? [
          {
            content: 'Ver PO en Brightpearl',
            external: true,
            url: brightPearlPoURL,
            icon: ViewMinor
          }] : []
        }
      >
        <div className="mb20">
          <div className='flex'>
            <div className="mb10 flex1">
              <DisplayText size="medium">
                {orderSupply.vendor}
              </DisplayText>
              <Badge status={"success"}>
                {I18n.t(`enum.status.${orderSupply.status}`)}
              </Badge>
            </div>
            {(!intcomexPoID && intcomexVendor) &&
              <div className='mb10 alignSelfCenter'>
                <Button
                  loading={loading}
                  onClick={submitCreatePO}
                >
                  Crear PO via API
                </Button>
              </div>
            }
          </div>

          <Card>
            {(intcomexVendor) && buildDataTable()}
            <DataTable
              columnContentTypes={dataTable.columnData}
              headings={dataTable.headData}
              verticalAlign="middle"
              rows={intcomexVendor ? dataTable.rows : dataTableRows}
            />

            {props.submitSyncURL &&
              <Card.Section>
                <ButtonGroup>
                  <Button
                    loading={loading}
                    onClick={submitSyncWithBrightPearl}
                  >
                    Sincronizar manualmente con Brightpearl
                  </Button>
                  <Button
                    loading={loading}
                    onClick={requestSpecialCost}
                  >
                    Consulta de costos especiales
                  </Button>
                </ButtonGroup>
              </Card.Section>
            }

          </Card>

          <InformativeModal
            open={resultModal.open}
            title={resultModal.title}
            columns={resultModal.columns}
            records={resultModal.records}
            errors={resultModal.errors}
            onClose={handleCloseModal}
          />
        </div>
      </Page>
    </AppProvider>
  )
};

OrderSupplyShow.propTypes = propTypes;
OrderSupplyShow.defaultProps = defaultProps;

export default OrderSupplyShow;
